export default __webpack_public_path__ + "static/media/outfit_fullsuit.a406a156.png";